import React from 'react';

export const Video = (props: any) => {
  return React.createElement('video', { ...props });
};
